import React from 'react'
import { ItemAttribute } from '../../../../types/interfaces'
import { unitTypeToText, valueTypeToInputType } from '../../../../utils/functions/enumToText'
import classes from './DynamicInput.module.sass'
import { ValueType } from '../../../../types/enums'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'

type Props = {
  el: ItemAttribute
  onChange: (id: string, value: string | string[] | boolean) => void
}

export const DynamicInput = ({ el, onChange }: Props) => {
  const dark = useSelector(selectDarkTheme)

  // Проверяем, заполнено ли поле
  const isFieldEmpty = () => {
    if (!el.isRequired) return false
    if (el.value === '' || el.value === false) return true
    if (Array.isArray(el.value) && el.value.length === 0) return true
    return false
  }

  const isEmpty = isFieldEmpty()

  // Определяем класс в зависимости от заполненности и темы
  const getInputClass = () => {
    if (dark) {
      return isEmpty ? classes.inputRequiredDark : classes.inputDark
    }
    return isEmpty ? classes.inputRequired : classes.input
  }

  return (
    <div className={classes.container}>
      <div className={classes.label}>{`${el.name}${
        el.valueType === ValueType.NUMBER ? `, ${unitTypeToText(el.unit)}` : ''
      }`}</div>
      <input
        className={getInputClass()}
        value={el.value as string}
        type={valueTypeToInputType(el.valueType)}
        onChange={(e) => onChange(String(el.id), e.target.value)}
      />
    </div>
  )
}
